import { withTheme } from "@hoc/withTheme";
import React from "react";

import { DASH_CHARACTER } from "../../constants";
import TestIds from "../../testIds";
import { PropsWithTheme } from "../../theme";
import { ListStyled, TitleStyled } from "./ReadOnlyList.styles";
import { IProps as IListItemProps, IReadOnlyListItem, ReadOnlyListItem } from "./ReadOnlyListItem";

/**
 * Formats value with "empty" fallback
 * @param value
 * @param formatter
 */
export function formatHeaderValue<T>(value: T, formatter?: ((value: T) => string)): string {
    return value ? (formatter ? formatter(value) : value as string) : DASH_CHARACTER;
}

export interface IProps extends PropsWithTheme, Pick<IListItemProps, "type"> {
    title?: string;
    data: IReadOnlyListItem[];
    withoutPadding?: boolean;
    testId?: string;
}

class ReadOnlyList extends React.PureComponent<IProps> {
    render() {
        return (
            <>
                {this.props.title && (<TitleStyled data-testid={TestIds.Title}>{this.props.title}</TitleStyled>)}
                <ListStyled data-testid={this.props.testId ?? TestIds.ReadOnlyList} $withoutPadding={this.props.withoutPadding}>
                    {this.props.data.map((item, idx) => (
                        <ReadOnlyListItem key={item.id ?? idx}
                                          type={this.props.type}
                                          {...item}
                                          value={item.value ?? DASH_CHARACTER}
                        />
                    ))}
                </ListStyled>
            </>
        );
    }
}

export default withTheme(ReadOnlyList);